import getStore from 'services/getStore';
import { focusBlockAction } from 'actions/focusBlockAction';

export default block => {
  getStore().dispatch(focusBlockAction(block));
};
